<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import GroupDevicesList from 'src/components/Groups/GroupDevicesList.svelte';

	export let list = [];
</script>

<SidepanelContent>
	{#key list}
		<GroupDevicesList devices={list} />
	{/key}
</SidepanelContent>
